import { ROLE, STAFF_LIST } from '../../consts/user';

export function staffMisOperations(items: any[], schoolId: string, callerRole: string, excluded: boolean) {
  if (![ROLE.ADMIN, ROLE.MANAGER].includes(callerRole)) return [];
  return items.reduce<Array<{userId: string; permissionId: string; data: {isExcludedFromMisIntegration: boolean}}>>((result, item) => result.concat((item.permissions || []).filter(permission => {
    const scope = permission.schoolId || permission.school?.id;
    return String(scope) === String(schoolId) && STAFF_LIST.includes(permission.preset) && permission.preset !== ROLE.SLT &&
      !(callerRole === ROLE.MANAGER && [ROLE.ADMIN, ROLE.MANAGER].includes(permission.preset)) &&
      (permission.isExcludedFromMisIntegration === true) !== excluded;
  }).map(permission => ({userId: item.id, permissionId: permission.id, data: {isExcludedFromMisIntegration: excluded}}))), []);
}
